module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Search")]), _vm._v(" "), _c('el-input', {
    staticClass: "col-md-6",
    attrs: {
      "placeholder": "search any urls",
      "type": "text"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filterByEachInput($event)
      }
    },
    model: {
      value: (_vm.searchvalue),
      callback: function($$v) {
        _vm.searchvalue = $$v
      },
      expression: "searchvalue"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    staticClass: "form",
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('p', [_vm._v("Add the URLS to be blocked here(each url on separate line)")]), _vm._v(" "), (_vm.inputVisible) ? _c('el-input', {
    ref: "saveTagInput",
    staticClass: "input-new-tag",
    attrs: {
      "size": "mini",
      "type": "textarea"
    },
    on: {
      "blur": _vm.handleInputConfirm
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleInputConfirm($event)
      }
    },
    model: {
      value: (_vm.inputValue),
      callback: function($$v) {
        _vm.inputValue = $$v
      },
      expression: "inputValue"
    }
  }) : _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.showInput
    }
  }, [_vm._v("+ Add URL")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticStyle: {
      "margin": "0px 0px 10px 0px"
    }
  }, [_c('button', {
    staticClass: "el-button el-button--info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_c('i', {
    staticClass: "el-icon-plus el-icon-left"
  }), _vm._v("\n                                Save\n                            ")]), _vm._v(" "), _c('router-link', {
    staticClass: "el-button el-button--danger",
    attrs: {
      "to": "/admin/domains/"
    }
  }, [_vm._v("\n                                Cancel\n                            ")])], 1)]), _vm._v(" "), (_vm.dynamicTagsCopy.length != _vm.dynamicTags.length) ? _c('p', {
    staticStyle: {
      "color": "red",
      "float": "right",
      "font-style": "italic"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("*")]), _vm._v(" NOT SAVED")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticClass: "button-new-tag el-button--danger",
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.openDeleteAllBlockUrlsModelBox(1)
      }
    }
  }, [_vm._v("Delete All blockedurls")]), _vm._v(" "), _c('el-button', {
    staticClass: "button-new-tag ",
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.deleteSelectedUrls(0)
      }
    }
  }, [_vm._v("Delete Selected blockedurls")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, _vm._l((_vm.dynamicTags), function(tag) {
    return _c('el-tag', {
      attrs: {
        "disable-transitions": false
      },
      on: {
        "close": function($event) {
          return _vm.handleClose(tag)
        }
      }
    }, [_c('a', {
      staticStyle: {
        "display": "inline-block",
        "width": "calc(100% - 50px)",
        "line-height": "30px",
        "overflow": "hidden",
        "text-overflow": "ellipsis"
      },
      attrs: {
        "href": tag.url,
        "target": "_blank"
      }
    }, [_vm._v("\n                                " + _vm._s(tag.url) + "\n                                "), _c('i', {
      staticClass: "fa fa-external-link",
      staticStyle: {
        "display": "inline",
        "margin-left": "5px",
        "line-height": "30px",
        "font-size": "20px"
      },
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), (tag.id == undefined) ? _c('span', {
      staticStyle: {
        "color": "red",
        "font-size": "30px"
      }
    }, [_vm._v("*")]) : _vm._e(), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedBlockurls),
        expression: "selectedBlockurls"
      }],
      staticStyle: {
        "float": "right"
      },
      attrs: {
        "type": "checkbox",
        "id": tag.id
      },
      domProps: {
        "value": tag.id,
        "checked": Array.isArray(_vm.selectedBlockurls) ? _vm._i(_vm.selectedBlockurls, tag.id) > -1 : (_vm.selectedBlockurls)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selectedBlockurls,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = tag.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedBlockurls = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedBlockurls = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedBlockurls = $$c
          }
        }
      }
    })])
  }), 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "pager-count": 20,
      "current-page": _vm.currentPage,
      "total": _vm.total_pages,
      "page-size": _vm.offset
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Block URLS")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8fec09ce!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/admin/BlockUrls.vue
// module id = 713
// module chunks = 2